import React from 'react';

const Button = ({ children, classes, icon, ...props }) => {
	return (
		<button type='button' {...props} className={`${classes && classes} btn fw-semibold`}>
			{icon && <i className={`${icon} me-2`}></i>}
			{children}
		</button>
	);
};

export default Button;
